import React, { useEffect } from 'react';
import './Latestoffer.css';
import PropTypes from 'prop-types';


function LatestOfferCard({ offer }) {
    useEffect(() => {
        const delay = 2; // Base delay for animations

        const fadeInElements = (selector, delayTime) => {
            const element = document.querySelector(selector);
            if (element) {
                setTimeout(() => {
                    element.style.opacity = 1; // Fade in effect
                }, delayTime);
            }
        };

        //  initial opacity to 0 for all elements
        const elements = [
            ".Banner6",
            ".BannerHolderEx6",
            ".BannerBorderEx6",
            ".BannerBorderLineEx6",
            ".SaleEx6",
            ".circleEx6",
            ".OffEx6"
        ];
        elements.forEach(selector => {
            const element = document.querySelector(selector);
            if (element) {
                element.style.opacity = 0;
            }
        });


        fadeInElements(".Banner6", delay);
        fadeInElements(".BannerBorderEx6", delay + 10);
        fadeInElements(".SaleEx6", delay + 27);
        fadeInElements(".circleEx6", delay + 26);
        fadeInElements(".OffEx6", delay + 2799);
    }, []);

    return (
        <div id="wrapper">
            <svg className="Banner6" viewBox="0 0 450 150" preserveAspectRatio="xMidYMid meet" style={{ opacity: 1 }}>
                {/* Border */}
                <polygon className="BannerBorderEx6" points="50 20, 30 130, 420 125, 440 40" style={{ opacity: 1, fill: 'NONE', stroke: 'rgb(185, 80, 71)', strokeWidth: 4.5 }} />

                {/* BannerHolder */}
                <polygon className="BannerHolderEx6" points="25 31, 10 125, 410 135, 430 40" style={{ opacity: 1, fill: 'white' }} />
                <defs>
                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" style={{ stopColor: 'rgb(155, 19, 74)', stopOpacity: 1 }} />
                        <stop offset="100%" style={{ stopColor: 'rgb(185, 80, 71)', stopOpacity: 1 }} />
                    </linearGradient>
                </defs>

                <polygon className="BannerHolderEx6" points="30 31, 15 120, 410 130, 430 20" fill="url(#gradient1)" />

                {/* Circle OFF & Triangles */}
                <circle className="circleEx6Shadow" opacity="0.5" cx="335" cy="75" r="65" stroke="#fff" strokeWidth="0" fill="#fff" />
                <circle className="circleEx6" cx="330" cy="75" r="65" stroke="#fff" strokeWidth="0" fill="rgb(155,19,74)" />

                {/* Texts */}
                <text className="SaleEx6" fontFamily="Josefin Sans" fontWeight="700" fontSize="50">
                    <tspan opacity="0.4" fill="#000" x="67" y="95">OFFER</tspan>
                    <tspan fill="#fff" x="65" y="90">OFFER</tspan>
                </text>

                <text className="OffEx6">
                    <tspan fontWeight="300" fontSize="20" fontFamily="Josefin Sans" fill="#fff" x="291" y="45">U P&nbsp;&nbsp;T O</tspan>
                    <tspan className="OffTextEx6" fontFamily="Frijole" fontSize="30" fontWeight="600" fill="#FFF" x="275" y="85">{`Rs. ${offer.offer}`}</tspan>
                    {/* <tspan fontWeight="300" fontSize="20" fontFamily="Josefin Sans" fill="#fff" x="306" y="124">O F F</tspan> */}
                </text>

                <polyline className="BorderAnimationEx6 BannerBorderLineEx6" points="50 20, 30 130" style={{ stroke: 'red', opacity: 0.5, strokeWidth: 4.5 }} />

                {/* Sorry, your browser does not support inline SVG. */}

            </svg>

        </div>
    );
}
LatestOfferCard.propTypes = {
    offer: PropTypes.array.isRequired,
};


export default LatestOfferCard;